import React from 'react';
import "./Mailbox.css";
import MailboxEmpty from "./MailboxEmpty.mjs";
import MailboxItem from "./MailboxItem.mjs";
import MailPreview from "./MailPreview.mjs";

const G = window.glob;

const Mailbox = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('Mailbox');
	}
	componentDidMount() {

	}
	render() {
		const msgs = this.props.data && this.props.data.length ? this.props.data.filter( m => m?.id ) : [];
		const read = this.props.read ?? {};
		return(
			<div className={"Mailbox "+this.props.box} id={this.uid}>
				{ msgs.length ? (
					<div className={"MailboxItems"}>
						{
							msgs.map(m => (
								<MailboxItem
									box={this.props.box}
									key={String(m.id) + read[m.id]}
									data={m}
									read={read[m.id]}
								/>
							))
						}
					</div>
				) : (
					<MailboxEmpty/>
				)}
				<MailPreview box={this.props.box} />
			</div>
		);
	}
}

export default Mailbox;